import { getCurrent } from "./roleType";

let authoritys;
let ignoreAuthority = false;

export function getAllUnrestricted() {
  ignoreAuthority = true;
  try {
    return getAll();
  } finally {
    ignoreAuthority = false;
  }
}

export function getAll() {
  const roleType = getCurrent();
  if (roleType === null) return [];
  if (roleType > 0) return getInternalItems(roleType);

  try {
    const storedAuthoritys = JSON.parse(
      window.localStorage["authorities"] || "[]"
    );
    authoritys = Array.isArray(storedAuthoritys) ? storedAuthoritys : [];
  } catch {
    authoritys = [];
  }
  const isERP = window.localStorage["isERP"] == "true";
  const productType = parseInt(window.localStorage["productType"]);
  const hasLY = window.localStorage["erpType"] == 1;
  const hasDWAPI = window.localStorage["erpType"] == 3;
  const inventoryMachineType = parseInt(
    window.localStorage["inventoryMachineType"]
  );

  let items = [
    {
      value: 0,
      name: "Basic",
      text: `基本資料`,
      categories: [
        {
          isShow: isShow(226),
          type: isShow(226) ? 226 : null,
          name: "Company",
          text: `公司資料`,
        },
        {
          isShow: isShow(6),
          type: isShow(6) ? 6 : null,
          name: "StoresAndTerminals",
          text: `門市與收銀台`,
        },
        {
          isShow: isShow(116),
          type: isShow(116) ? 116 : null,
          name: "Departments",
          text: `部門`,
        },
        {
          isShow: isShow(2),
          type: isShow(2) ? 2 : null,
          name: "EmployeesAndAuthority",
          text: `員工與權限`,
        },
        {
          isShow: isShow(1),
          type: isShow(1) ? 1 : null,
          name: "Foods",
          text: `商品`,
        },
        {
          isShow: isShow(37),
          type: isShow(37) ? 37 : null,
          name: "TasteKinds",
          text: `口味`,
        },
        {
          isShow: isShow(38),
          type: isShow(38) ? 38 : null,
          name: "ComboKinds",
          text: `套餐`,
        },
        {
          isShow: isShow(43),
          type: isShow(43) ? 43 : null,
          name: "Promotion",
          text: `促銷`,
        },
        {
          isShow: isShow(87),
          type: isShow(87) ? 87 : null,
          name: "Pays",
          text: `付款別`,
        },
        {
          isShow: isShow(12),
          type: isShow(12) ? 12 : null,
          name: "DirectoryKinds",
          text: `科目`,
        },
        {
          isShow: isShow(61),
          type: isShow(61) ? 61 : null,
          name: "Day",
          text: `時間模組`,
        },
        {
          isShow: isShow(141),
          type: isShow(141) ? 141 : null,
          name: "Accounts",
          text: `帳戶`,
        },
        {
          isShow: isShow(68),
          type: isShow(68) ? 68 : null,
          name: "PriceLabels",
          text: `價格標`,
        },
        {
          isShow: isShow(248),
          type: isShow(248) ? 248 : null,
          name: "Pickups",
          text: `取貨方式`,
        },
        // {
        //   isShow: isShow(227),
        //   name: "Brands",
        //   text: `品牌`,
        // },
        {
          isShow: isShow(255),
          type: isShow(255) ? 255 : null,
          name: "Nationality",
          text: "國籍",
        },
      ],
    },
    {
      value: 1,
      name: "Report",
      text: `報表`,
      categories: [
        {
          value: 0,
          name: "SaleReports",
          text: `銷售`,
          subcategories: [
            {
              isShow: isShow(90),
              type: isShow(90) ? 90 : null,
              name: "ReportSale",
              text: `銷售報表`,
            },
            {
              isShow: isShow(114),
              type: isShow(114) ? 114 : null,
              name: "ReportClassSale",
              text: `班別報表`,
            },
            {
              isShow: isShow(19),
              type: isShow(19) ? 19 : null,
              name: "ReportInvoice",
              text: `發票報表`,
            },
            {
              isShow: isShow(176),
              type: isShow(176) ? 176 : null,
              name: "ReportInvoicePrize",
              text: `中獎發票報表`,
            },
            {
              isShow: isShow(18),
              type: isShow(18) ? 18 : null,
              name: "ReportEmployeeAnalysis",
              text: `員工報表`,
            },
            {
              isShow: isShow(110),
              type: isShow(110) ? 110 : null,
              name: "ReportWorkRecord",
              text: `員工出勤報表`,
            },
            {
              isShow: isShow(120),
              type: isShow(120) ? 120 : null,
              name: "ReportSaler",
              text: `業務員報表`,
            },
            {
              isShow: isShow(21),
              type: isShow(21) ? 21 : null,
              name: "ReportPeople",
              text: `人數報表`,
            },
            {
              isShow: isShow(153),
              type: isShow(153) ? 153 : null,
              name: "ReportCoupon",
              text: `折價券報表`,
            },
            {
              isShow: isShow(140),
              type: isShow(140) ? 140 : null,
              name: "ReportSaleOrder",
              text: `訂單報表`,
            },
            {
              isShow: isShow(22),
              type: isShow(22) ? 22 : null,
              name: "ReportCollectionPayment",
              text: `代收代支表`,
            },
            {
              isShow: isShow(207),
              type: isShow(207) ? 207 : null,
              name: "ReportSaleProfit",
              text: `銷售利潤報表`,
            },
            {
              isShow: isShow(225),
              type: isShow(225) ? 225 : null,
              name: "ReportCreditCard",
              text: `信用卡交易表`,
            },
            {
              isShow: isShow(228),
              type: isShow(228) ? 228 : null,
              name: "ReportBusinessRecord",
              text: `日結紀錄表`,
            },
            {
              isShow: isShow(121),
              type: isShow(121) ? 121 : null,
              name: "ReportDeleteFood",
              text: `退菜報表`,
            },
            {
              isShow: isShow(278),
              type: isShow(278) ? 278 : null,
              name: "ReportKioskRecord",
              text: `找零異動表`,
            },
            {
              isShow: isShow(147),
              type: isShow(147) ? 147 : null,
              name: "ReportOrderFoodStatistic",
              text: `訂單商品統計表`,
              borderLine: true,
            },
            {
              isShow: isShow(108),
              type: isShow(108) ? 108 : null,
              name: "ReportFoodMajorKindStatistic",
              text: `大類統計表`,
            },
            {
              isShow: isShow(15),
              type: isShow(15) ? 15 : null,
              name: "ReportFoodKindStatistic",
              text: `類別統計表`,
            },
            {
              isShow: isShow(20),
              type: isShow(20) ? 20 : null,
              name: "ReportFoodSaleStatistic",
              text: `商品銷售統計表`,
            },
            {
              isShow: isShow(149),
              type: isShow(149) ? 149 : null,
              name: "ReportFoodDayStatistic",
              text: `商品日統計表`,
            },
            {
              isShow: isShow(131),
              type: isShow(131) ? 131 : null,
              name: "ReportFoodSale",
              text: `商品銷售表`,
            },
            {
              isShow: isShow(17),
              type: isShow(17) ? 17 : null,
              name: "ReportFree",
              text: `招待報表`,
            },
            {
              isShow: isShow(77),
              type: isShow(77) ? 77 : null,
              name: "ReportTimeStatistic",
              text: `時段統計表`,
            },
            {
              isShow: isShow(111),
              type: isShow(111) ? 111 : null,
              name: "ReportTasteStatistic",
              text: `口味統計表`,
            },
            {
              isShow: isShow(245),
              type: isShow(245) ? 245 : null,
              name: "ReportFoodTasteStatistic",
              text: `商品口味統計表`,
            },
            {
              isShow: isShow(74),
              type: isShow(74) ? 74 : null,
              name: "ReportPay",
              text: `付款類別報表`,
              borderLine: true,
            },
            {
              isShow: isShow(75),
              type: isShow(75) ? 75 : null,
              name: "ReportSalePay",
              text: `付款別報表`,
            },
          ],
        },
        {
          value: 1,
          name: "ERPReports",
          text: `進銷存`,
          subcategories: [
            {
              isShow: isShow(63),
              type: isShow(63) ? 63 : null,
              name: "ReportSupplier",
              text: `廠商交易報表`,
            },
            {
              isShow: isShow(177),
              type: isShow(177) ? 177 : null,
              name: "ReportSupplierFoodSale",
              text: `廠商商品銷售表`,
            },
            {
              isShow: isShow(190),
              type: isShow(190) ? 190 : null,
              name: "ReportSupplierFoodSaleOriginal",
              text: `廠商商品銷售表(原價)`,
            },
            {
              isShow: isShow(138),
              type: isShow(138) ? 138 : null,
              name: "ReportSupplierPurchaseOrder",
              text: `廠商採購明細表`,
            },
            {
              isShow: isShow(194),
              type: isShow(194) ? 194 : null,
              name: "ReportFoodPurchaseOrder",
              text: `商品採購表`,
            },
            {
              isShow: isShow(132),
              type: isShow(132) ? 132 : null,
              name: "ReportFoodPurchase",
              text: `商品進貨表`,
            },
            {
              isShow: isShow(158),
              type: isShow(158) ? 158 : null,
              name: "ReportERPSummary",
              text: `商品進銷存彙總表`,
            },
            {
              isShow: isShow(137),
              type: isShow(137) ? 137 : null,
              name: "ReportPurchaseOrder",
              text: `採購單報表`,
            },
            {
              isShow: isShow(24),
              type: isShow(24) ? 24 : null,
              name: "ReportPurchase",
              text: `進貨單報表`,
            },
            {
              isShow: isShow(25),
              type: isShow(25) ? 25 : null,
              name: "ReportPurchaseReturn",
              text: `進退單報表`,
            },
            {
              isShow: isShow(71),
              type: isShow(71) ? 71 : null,
              name: "ReportStockAdjust",
              text: `調整單報表`,
            },
            {
              isShow: isShow(187),
              type: isShow(187) ? 187 : null,
              name: "ReportStockAdjustDirectory",
              text: `調整科目統計表`,
            },
            {
              isShow: isShow(173),
              type: isShow(173) ? 173 : null,
              name: "ReportStockTransfers",
              text: `調撥單報表`,
            },
            {
              isShow: isShow(152),
              type: isShow(152) ? 152 : null,
              name: "ReportInventory",
              text: `盤點單報表`,
            },
            {
              isShow: isShow(69),
              type: isShow(69) ? 69 : null,
              name: "ReportStock",
              text: `庫存現量表`,
            },
            {
              isShow: isShow(70),
              type: isShow(70) ? 70 : null,
              name: "ReportSafeQty",
              text: `低於安全存量表`,
            },
            {
              isShow: isShow(115),
              type: isShow(115) ? 115 : null,
              name: "ReportInventoryPAndL",
              text: `盤點盈虧表`,
            },
            {
              isShow: isShow(23),
              type: isShow(23) ? 23 : null,
              name: "ReportFoodMovement",
              text: `商品異動表`,
            },
            {
              isShow: isShow(205),
              type: isShow(205) ? 205 : null,
              name: "ReportStockBatch",
              text: `批號庫存現量表`,
            },
            {
              isShow: isShow(206),
              type: isShow(206) ? 206 : null,
              name: "ReportStockBatchMovement",
              text: `批號庫存異動表`,
            },
            {
              isShow: isShow(170),
              type: isShow(170) ? 170 : null,
              name: "ReportCombinationTrade",
              text: `組合單報表`,
              borderLine: true,
            },
            {
              isShow: isShow(171),
              type: isShow(171) ? 171 : null,
              name: "ReportSeparationTrade",
              text: `拆解單報表`,
            },
            {
              isShow: isShow(277),
              type: isShow(277) ? 277 : null,
              name: "ReportMonthlyCost",
              text: `月成本報表`,
              borderLine: true,
            },
          ],
        },
        {
          value: 2,
          name: "CustomerReports",
          text: `會員`,
          subcategories: [
            {
              isShow: isShow(89),
              type: isShow(89) ? 89 : null,
              name: "ReportCustomer",
              text: `會員交易報表`,
            },
            {
              isShow: isShow(186),
              type: isShow(186) ? 186 : null,
              name: "ReportCustomerFoodSale",
              text: `會員商品銷售表`,
            },
            {
              isShow: isShow(166),
              type: isShow(166) ? 166 : null,
              name: "ReportCustomerSaleStatistic",
              text: `會員銷售統計表`,
            },
            {
              isShow: isShow(113),
              type: isShow(113) ? 113 : null,
              name: "ReportDeposit",
              text: `儲值交易報表`,
            },
            {
              isShow: isShow(118),
              type: isShow(118) ? 118 : null,
              name: "ReportIntegral",
              text: `積點交易報表`,
            },
            {
              isShow: isShow(135),
              type: isShow(135) ? 135 : null,
              name: "ReportCustomerStock",
              text: `會員庫存表`,
            },
            {
              isShow: isShow(134),
              type: isShow(134) ? 134 : null,
              name: "ReportCustomerStockMovement",
              text: `會員庫存異動表`,
            },
            {
              isShow: isShow(210),
              type: isShow(210) ? 210 : null,
              name: "ReportCustomerFree",
              text: `會員招待報表`,
            },
            {
              isShow: isShow(195),
              type: isShow(195) ? 195 : null,
              name: "ReportPGTalkDeposit",
              text: `PGTalk儲值交易表`,
            },
          ],
        },
        {
          value: 3,
          name: "OtherReports",
          text: `其他`,
          subcategories: [
            {
              isShow: isShow(251),
              type: isShow(251) ? 251 : null,
              name: "ReportUploadLogs",
              text: `第三方上傳記錄`,
            },
            {
              isShow: isShow(285),
              type: isShow(285) ? 285 : null,
              name: "ReportCreditCardCommunication",
              text: `刷卡交易通訊紀錄`,
            },
            {
              isShow: isShow(286),
              type: isShow(286) ? 286 : null,
              name: "ReportLoginLog",
              text: `登入紀錄表`,
            },
          ],
        },
      ],
    },
    {
      value: 2,
      name: "Customer",
      text: `會員管理`,
      categories: [
        {
          isShow: isShow(3),
          type: isShow(3) ? 3 : null,
          name: "Customers",
          text: `會員資料`,
        },
        {
          isShow: isShow(191) || isShow(189) || isShow(250),
          type: isShow(191)
            ? 191
            : isShow(189)
            ? 189
            : isShow(250)
            ? 250
            : null,
          name: "MemberSetting",
          text: `會員設定`,
        },
        {
          isShow: isShow(211),
          type: isShow(211) ? 211 : null,
          name: "MemberWeb",
          text: `會員網站`,
        },
        {
          isShow: isShow(252),
          type: isShow(252) ? 252 : null,
          name: "EventSetting",
          text: `行銷活動`,
        },
      ],
    },
    {
      value: 3,
      name: "ERP",
      text: hasLY
        ? "凌越進銷存"
        : hasDWAPI
        ? "鼎新進銷存"
        : isERP
        ? "進銷存"
        : productType == 3
        ? "單據"
        : "進銷存",
      categories: [
        {
          isShow: isShow(5),
          type: isShow(5) ? 5 : null,
          name: "Warehouses",
          text: `倉庫`,
        },
        {
          isShow: isShow(4),
          type: isShow(4) ? 4 : null,
          name: "Suppliers",
          text: `廠商`,
        },
        {
          isShow: isShow(33),
          type: isShow(33) ? 33 : null,
          name: "SafeQty",
          text: `安全存量`,
        },
        {
          isShow: isShow(145) && hasLY,
          type: isShow(145) && hasLY ? 145 : null,
          name: "LYStock",
          text: "庫存",
        },
        {
          isShow: isShow(145) && hasDWAPI,
          type: isShow(145) && hasDWAPI ? 145 : null,
          name: "DWStock",
          text: "庫存",
        },
        {
          isShow: isShow(247),
          type: isShow(247) ? 247 : null,
          name: "Orders",
          text: `訂購單`,
          borderLine: isShow(247),
        },
        {
          isShow: isShow(27),
          type: isShow(27) ? 27 : null,
          name: "Sals",
          text: `銷貨單`,
          borderLine: true,
        },
        {
          isShow: isShow(28),
          type: isShow(28) ? 28 : null,
          name: "SalReturns",
          text: `銷貨退出單`,
        },
        {
          isShow: isShow(279),
          type: isShow(279) ? 279 : null,
          name: "Requisitions",
          text: `請購單`,
          borderLine: true,
        },
        {
          isShow: isShow(125),
          type: isShow(125) ? 125 : null,
          name: "PurchaseOrders",
          text: `採購單`,
          borderLine: !hasDWAPI,
        },
        {
          isShow: isShow(29),
          type: isShow(29) ? 29 : null,
          name: "Purchases",
          text: `進貨單`,
        },
        {
          isShow: isShow(30),
          type: isShow(30) ? 30 : null,
          name: "PurchaseReturns",
          text: `進貨退出單`,
        },
        {
          isShow: isShow(31),
          type: isShow(31) ? 31 : null,
          name: "StockAdjusts",
          text: `調整單`,
          borderLine: true,
        },
        {
          isShow: isShow(92),
          type: isShow(92) ? 92 : null,
          name: "StockTransfers",
          text: `調撥單`,
        },
        {
          isShow: isShow(32),
          type: isShow(32) ? 32 : null,
          name: "Inventorys",
          text: `盤點單`,
        },
        {
          isShow: inventoryMachineType > 0 && isERP,
          name: "InventoryMachine",
          text: `盤點機`,
        },
        {
          isShow: isShow(167),
          type: isShow(167) ? 167 : null,
          name: "Combinations",
          text: "組合品",
          borderLine: true,
        },
        {
          isShow: isShow(168),
          type: isShow(168) ? 168 : null,
          name: "CombinationTrades",
          text: "組合單",
        },
        {
          isShow: isShow(169),
          type: isShow(169) ? 169 : null,
          name: "SeparationTrades",
          text: "拆解單",
        },
        {
          isShow: isShow(258),
          type: isShow(258) ? 258 : null,
          name: "MonthlyCostClosing",
          text: "成本月結",
          borderLine: true,
        },
      ],
    },
    {
      value: 4,
      name: "Account",
      text: `帳款`,
      categories: [
        {
          isShow: isShow(67),
          type: isShow(67) ? 67 : null,
          name: "Receivables",
          text: `應收帳款`,
        },
        {
          isShow: isShow(36),
          type: isShow(36) ? 36 : null,
          name: "Receipts",
          text: `收款單`,
        },
        {
          isShow: isShow(65),
          type: isShow(65) ? 65 : null,
          name: "Payables",
          text: `應付帳款`,
          borderLine: true,
        },
        {
          isShow: isShow(35),
          type: isShow(35) ? 35 : null,
          name: "Payments",
          text: `付款單`,
        },
      ],
    },
    {
      value: 5,
      name: "OnlineOrder",
      text: `串接`,
      categories: [
        {
          isShow: isShow(273),
          type: isShow(273) ? 273 : null,
          name: "UberEats",
          text: `UberEats`,
        },
        {
          isShow: isShow(275),
          type: isShow(275) ? 275 : null,
          name: "KDS",
          text: `KDS`,
        },
        {
          isShow: isShow(192),
          type: isShow(192) ? 192 : null,
          name: "Ocard",
          text: `Ocard`,
        },
        {
          isShow: isShow(276),
          type: isShow(276) ? 276 : null,
          name: "LineOA",
          text: `Line OA`,
        },
      ],
    },
    {
      isShow: isShow(81),
      value: 6,
      name: "Download",
      text: `下傳`,
    },
  ];
  return items;
}

function getInternalItems(roleType) {
  const items = [
    {
      value: 89,
      name: "OldVersionBasic",
      text: "基本資料",
      categories: [
        { isShow: true, name: "OldVersionBusinesses", text: "營業人" },
        { isShow: true, name: "OldVersionUsers", text: "使用者" },
        { isShow: true, name: "OldVersionUtaiForms", text: "友泰申請單" },
        { isShow: true, name: "OldVersionUShowForms", text: "百揚需求信" },
        { isShow: true, name: "OldVersionInvoicePrizes", text: "中獎名單" },
        { isShow: true, name: "OldVersionLicenses", text: "終端機授權" },
      ],
    },
  ];

  if ([2, 6].includes(roleType)) {
    items.push({
      value: 90,
      name: "OldVersionLogs",
      text: "Log",
      categories: [
        {
          isShow: true,
          name: "OldVersionErrorMessage",
          text: "錯誤訊息",
        },
        {
          isShow: true,
          name: "OldVersionThirdPartyLog",
          text: "第三方",
        },
        {
          isShow: true,
          name: "OldVersionSystemLog",
          text: "系統",
        },
        {
          isShow: true,
          name: "OldVersionNotificationLog",
          text: "推播",
        },
        {
          isShow: true,
          name: "OldVersionWebhookLog",
          text: "回呼",
        },
      ],
    });
  }

  if (roleType === 3) {
    items.push({
      value: 91,
      name: "OldVersionAccount",
      text: "帳款",
      categories: [
        {
          isShow: true,
          name: "OldVersionPYReceivables",
          text: "應收帳款",
        },
      ],
    });
  }

  return items;
}

export function getByValue(value) {
  const type = getAll().find((item) => {
    return item.value == value;
  });
  return type;
}

function isShow(id) {
  if (ignoreAuthority) return true;
  const authority = authoritys.find((data) => {
    return data.AuthItemType == id;
  });
  if (authority) {
    if (authority.IsList) return true;
  }
  return false;
}
